export const SET_TABLE_COLUMNS_ORDER = "SET_TABLE_COLUMNS_ORDER";
export const CLEAN_TABLE_COLUMNS_ORDER = "CLEAN_TABLE_COLUMNS_ORDER";
